import { render, staticRenderFns } from "./transferEmployee.vue?vue&type=template&id=db3a8bb2"
import script from "./transferEmployee.vue?vue&type=script&lang=js"
export * from "./transferEmployee.vue?vue&type=script&lang=js"
import style0 from "./transferEmployee.vue?vue&type=style&index=0&id=db3a8bb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports